import { render, staticRenderFns } from "./PrimeCheckbox.vue?vue&type=template&id=11a4e412&scoped=true"
import script from "./PrimeCheckbox.vue?vue&type=script&lang=js"
export * from "./PrimeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PrimeCheckbox.vue?vue&type=style&index=0&id=11a4e412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a4e412",
  null
  
)

export default component.exports